import {createEntityService} from 'utils/createEntityService';
import {BillingSolution} from 'types/billingSolution';

export const BillingSolutionService = createEntityService<BillingSolution>({
  baseUrl: 'api/v1/billing_solutions',
  entityName: 'billingSolution',
});
